// src/config/permissions.js
//
// Capability -> roles permitted to exercise it. This is a UI convenience only:
// the server is the authorization boundary and must enforce every one of these
// independently. Hiding a control prevents accidental misuse by legitimate
// staff; it does not stop a crafted request.

export const CAPABILITIES = {
    KYC_VIEW: "KYC_VIEW",
    KYC_DECIDE: "KYC_DECIDE",
    PRICING_EDIT: "PRICING_EDIT",
    LEDGER_ACCESS: "LEDGER_ACCESS",
    CLOSURE_REVIEW: "CLOSURE_REVIEW",
    WAYA_OFFICIAL: "WAYA_OFFICIAL",
    SETTLEMENT_MANUAL: "SETTLEMENT_MANUAL",
  };
  
  export const CAPABILITY_ROLES = {
    [CAPABILITIES.KYC_VIEW]: ["ROLE_ADMIN_OWNER", "ROLE_ADMIN_SUPER", "ROLE_ADMIN_APP"],
    [CAPABILITIES.KYC_DECIDE]: ["ROLE_ADMIN_OWNER", "ROLE_ADMIN_SUPER"],
    [CAPABILITIES.PRICING_EDIT]: ["ROLE_ADMIN_OWNER", "ROLE_ADMIN_SUPER", "ROLE_ADMIN_APP"],
    [CAPABILITIES.LEDGER_ACCESS]: ["ROLE_ADMIN_OWNER"],
    [CAPABILITIES.CLOSURE_REVIEW]: ["ROLE_ADMIN_OWNER", "ROLE_ADMIN_SUPER", "ROLE_ADMIN_APP"],
    [CAPABILITIES.WAYA_OFFICIAL]: ["ROLE_ADMIN_OWNER"],
    [CAPABILITIES.SETTLEMENT_MANUAL]: ["ROLE_ADMIN_OWNER", "ROLE_ADMIN_SUPER"],
  };